import {
    LOAD_MENUS_FOR_CSV_CREATE_EDIT_SUCCESS,
    LOAD_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS,
    LOAD_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS,
    RESET_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS,
    RESET_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = {
    menus: [],
    categories: [],
    products: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_MENUS_FOR_CSV_CREATE_EDIT_SUCCESS:
            return {
                ...state,
                menus: action.payload
            };
        case LOAD_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS:
            return {
                ...state,
                categories: action.payload
            };
        case LOAD_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS:
            return {
                ...state,
                products: action.payload
            }
        case RESET_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS: 
            return {
                ...state,
                categories: []
            }
        case RESET_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS:
            return {
                ...state,
                products: []
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/MenuCategoryProductReducer.js